import Zoomable from './zoomable'

export default function InitZoomables(selector='.mx-zoomable-wrapper') {
  const images = Array.from(document.querySelectorAll(selector))

  if ( images.length === 0 ) {
    return
  }

  const zoomBackground = document.createElement('div')
  zoomBackground.classList.add('mx-zoomable-background')
  document.body.appendChild(zoomBackground)
  // const body = document.body
  // body.insertBefore(zoomBackground, body.firstChild)
  
  images.forEach((image, index) => {
    new Zoomable(image, index)
  })
}